// extracted by css-extract-rspack-plugin
export default {"MobileHamburgerIcon":"uGr0f"};